import { useSelector } from 'react-redux';

import { AncillaryService, getAncillaryServices } from '@apis/ancillaryServices';

import { useAxiosQuery, UseAxiosQueryOptions } from '@hooks/useAxiosQuery';

import { getCurrentSiteState, getLocaleState } from '@redux/selectors';

const ancillaryServicesKey = 'ancillary_services';

export const useGetAncillaryServices = <TResult = AncillaryService[]>(
  options?: UseAxiosQueryOptions<AncillaryService[], TResult>,
) => {
  const apiBaseUrl = API_BASE_URL;
  const locale = useSelector(getLocaleState);
  const currentSiteCode = useSelector(getCurrentSiteState);

  return useAxiosQuery({
    queryKey: [
      ancillaryServicesKey,
      {
        locale,
        currentSiteCode: currentSiteCode.countryCode,
      },
    ],
    queryFn: () => getAncillaryServices(apiBaseUrl, currentSiteCode.countryCode, locale),
    ...options,
  });
};
